import { Component, Input, OnInit, Pipe, PipeTransform, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { TealiumUtagService } from '../../../../tealium/utag.service';

@Component({
  selector: 'app-event-description',
  templateUrl: './event-description.component.html',
  styleUrls: [],
  encapsulation: ViewEncapsulation.None
})
export class EventDescriptionComponent implements OnInit {

  @Input() image: string;
  @Input() name: string;
  @Input() type: string;
  @Input() description: string;
  @Input() axeHasCommercialEvents: string;
  eventUrl: string;
  constructor(
    private sanitized: DomSanitizer,
    private route: ActivatedRoute,
    private tealium: TealiumUtagService
  ) { }

  ngOnInit() {
    this.eventUrl = window.location.href;
  }

  /**
   * Envoie les infos utag
   * @param track_zone | string : Nom du tracking
   * @param track_nom | string : Nom du tracking
   * @param track_cible | string : Slug du tracking
   */
   public sendLink(track_zone, track_nom, track_cible = "") {
    console.log("🚀 ~ file: prestation.component.ts ~ line 227 ~ PrestationComponent ~ sendLink ~ this.route.snapshot.paramMap.get('bu') + '_' + track_zone", this.route.snapshot.paramMap.get('bu') + '_' + track_zone)
    console.log("🚀 ~ file: prestation.component.ts ~ line 229 ~ PrestationComponent ~ sendLink ~ track_nom", track_nom)
    console.log("🚀 ~ file: prestation.component.ts ~ line 231 ~ PrestationComponent ~ sendLink ~ window.location.href + '/' + track_cible", window.location.href + '/' + track_cible)
    this.tealium.link({
      'track_zone': this.route.snapshot.paramMap.get('bu') + '_' + track_zone,
      'track_nom': track_nom,
      'track_cible': window.location.href + '/' + track_cible
    });
  }

}

@Pipe({ name: 'safeHtml'})
export class SafeHtmlPipe implements PipeTransform  {
  constructor(private sanitized: DomSanitizer) {}
  transform(value) {
    return this.sanitized.bypassSecurityTrustHtml(value);
  }
}


// WEBPACK FOOTER //
// ./src/app/screens/register-event/view/event-description/event-description.component.ts